export const aiMessage = "a1ot4o92";
export const aiHeader = "a1x053e6";
export const userMessage = "ux0nr0e";
export const divider = "d5clpsr";

/**
 * ==============================================
 * Dot Typing
 * ==============================================
 */

export const dotTyping = "d1g24cfb";
export const cardRow = "c10cs8kn";

require("./style.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");